var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseModule } from './../commons/BaseModule';
import Vue from 'vue';
var EventsModule = (function (_super) {
    __extends(EventsModule, _super);
    function EventsModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EventsModule.prototype.preInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            Vue.prototype.$emitBubble = _this.emitBubble;
            Vue.prototype.$emitBubbleFirst = _this.emitBubbleFirst;
            resolve(true);
        });
    };
    EventsModule.prototype.finalizeInstall = function (options) {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };
    EventsModule.prototype.emitBubble = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var node = this;
        while (node) {
            node.$emit.apply(node, [event].concat(args));
            node = node.$parent;
        }
    };
    EventsModule.prototype.emitBubbleFirst = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var node = this;
        while (node) {
            node.$emit.apply(node, [event].concat(args));
            if (node.$listeners[event])
                return;
            node = node.$parent;
        }
    };
    return EventsModule;
}(BaseModule));
export default EventsModule;



//////////////////
// WEBPACK FOOTER
// ./src/modules/events/index.ts
// module id = null
// module chunks = 